// extracted by mini-css-extract-plugin
module.exports = {"nodesContainer":"SuggestionsTray_nodesContainer__1Qa6p"};